import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";
import { House, Envelope, Users, Article, MagnifyingGlass, Scales, SignOut } from "@phosphor-icons/react";

const NAV = [
  { to: "/admin", label: "Tableau de bord", icon: House, end: true },
  { to: "/admin/leads", label: "Demandes reçues", icon: Envelope },
  { to: "/admin/partenaires", label: "Partenaires", icon: Users },
  { to: "/admin/contenus", label: "Contenus", icon: Article },
  { to: "/admin/seo", label: "SEO", icon: MagnifyingGlass },
  { to: "/admin/mentions", label: "Mentions légales", icon: Scales },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-ducs-night text-ducs-cream flex">
      <aside data-testid="admin-sidebar" className="w-64 shrink-0 border-r border-ducs-gold/15 bg-ducs-night flex flex-col">
        <div className="px-6 py-6 border-b border-ducs-gold/10 flex items-center gap-3">
          <LogoMark className="h-9 w-9" />
          <div className="leading-tight">
            <div className="font-serif text-ducs-gold tracking-wide">Console</div>
            <div className="text-[10px] tracking-[0.25em] text-ducs-mist uppercase">Courtage des Ducs</div>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${to.split("/").pop() || "home"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive ? "bg-ducs-gold/15 text-ducs-gold" : "text-ducs-cream/80 hover:bg-ducs-navy"
                }`
              }
            >
              <Icon size={18} weight="duotone" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-ducs-gold/10">
          <div className="text-xs text-ducs-mist mb-2">{user?.email}</div>
          <button onClick={onLogout} data-testid="admin-logout" className="flex items-center gap-2 text-sm text-ducs-cream/80 hover:text-ducs-gold">
            <SignOut size={16} /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
